import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/developer.png'


const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "login-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_login_panel = _resolveComponent("login-panel")!
  const _component_IcpFooter = _resolveComponent("IcpFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "login-left" }, [
      _createElementVNode("div", { class: "login-left-div animate__animated animate__bounceInLeft animate__fast" }, [
        _createElementVNode("h2", null, "Weblog 博客登录"),
        _createElementVNode("p", null, "一款由 Spring Boot + Mybaits Plus + Vue 3.2 + Vite 4 开发的前后端分离博客。"),
        _createElementVNode("img", {
          src: _imports_0,
          width: "50%"
        })
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_login_panel)
    ]),
    _createVNode(_component_IcpFooter, { class: "login-icp" })
  ]))
}